module.exports = __webpack_public_path__ + "static/media/veryvell_6_filter.03e3ecc6.png";